import React from 'react';
import ReactDOM from 'react-dom';
import {importScript} from '@ruhnn/common/common/util';
import App from './App';

if (process.env.NODE_ENV === 'development') {
    importScript('https://cdn.bootcss.com/vConsole/3.2.0/vconsole.min.js').then(() => {
        // eslint-disable-next-line no-unused-vars
        const vConsole = new window.VConsole();
        ReactDOM.render(<App />, document.querySelector('#app'));
    });
}
ReactDOM.render(<App />, document.querySelector('#app'));
